/*
 * 2018年终回顾 大屏
 */
let URL =
  process.env.VUE_APP_MOCK == 'true' || window.location.hostname === '127.0.0.1'
    ? '//test-bigscreen.iwencai.com/macrod/screen/getNinthScreenData'
    : '/macrod/screen/getSeventhScreenData';
// const URL = process.env.VUE_APP_MOCK == 'true' ? '//yapi.10jqka.com.cn/mock/105/screen9' : '/macrod/screen/getSeventhScreenData';

URL = '//ai.iwencai.com/macrod/screen/getNinthScreenData';
class Screen9 {
  // 获取经济数据
  getData() {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: URL,
        // dataType: 'jsonp',
        // data: params,
        success: data => {
          resolve(data);
        }
      });
    });
  }
}

export default new Screen9();
